/* eslint no-useless-escape: ["off"] */
import _ from 'lodash';

const getErrorMessageFromErrorStatus = (errorStatus) => {
  if (errorStatus === 500) {
    return { serverError: `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}` };
  }
  if (errorStatus === 422) {
    return { serverError: 'กรอกข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง' };
  }
};

const validateTitle = (title) => {
  if (!title) {
    return { title: 'โปรดระบุชื่อ' };
  }
  return { title: null };
};


const isContentCategoryValid = (contentCategory, status) => {
  if (status && status !== 'draft') {
    return !!contentCategory;
  }
  return true;
};

const validateContentCategory = (contentCategory, status, errorState) => {
  const contentCategoryError = _.get(errorState, 'contentCategory', null);
  const isValid = isContentCategoryValid(contentCategory, status);

  if (!isValid) {
    return { contentCategory: 'กรุณาใส่หมวดหมู่คอนเทนท์ หรือตั้งสถานะการเผยแพร่เป็น ‘Draft’ ในกรณีที่ยังไม่ต้องการระบุค่า' };
  }
  if (isValid && contentCategoryError) {
    return { contentCategory: null };
  }
};

const validateAgeCategory = (ageCategory) => {
  if (!ageCategory) {
    return { ageCategory: 'กรุณาใส่ช่วงอายุที่ต้องการ' };
  }
  return { ageCategory: null };
};
const validateSubjectCategory = (subjectCategory) => {
  if (!subjectCategory) {
    return { subjectCategory: 'กรุณาใส่รายวิชาที่ต้องการ' };
  }
  return { subjectCategory: null };
};

const validateProgram = (programId) => {
  if (!programId) {
    return { programId: 'กรุณาเลือกรายการ' };
  }
  return { programId: null };
};

const checkFormat = (string) => {
  return /^[a-zA-Z0-9-]+$/g.test(string);
};

const validateProgramKey = (key) => {
  if (!key || key.length < 3) {
    return { key: 'ระบุคีย์รายการมากกว่า 3 ตัวอักษร' };
  } if (!checkFormat(key)) {
    return { key: 'ระบุคีย์ที่ประกอบด้วยภาษาอังกฤษหรือ - โดยไม่มีอักขระพิเศษ' };
  }
  return { key: null };
};

const valdiateEmail = (email) => {
  if (!email) return;
  const format = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!format.test(email)) {
    return { mail: 'กรุณากรอกอีเมลให้ถูกต้อง' };
  }
  return { mail: null };
};

export {
  getErrorMessageFromErrorStatus,
  validateTitle,
  validateContentCategory,
  validateProgram,
  validateProgramKey,
  valdiateEmail,
  validateAgeCategory,
  validateSubjectCategory,
};
